/* eslint-disable @typescript-eslint/no-explicit-any */
import {Injectable} from '@angular/core';
import {ModalService} from '../modal-service.service';
import {TenureInterestsNotificationModalComponent} from './tenure-interest-notification-modal.component';

export interface TenureInterestsNotificationModalProps {
    tenureInterestNotification: any;
    overwritableSubjectVals: any;
}

@Injectable({
    providedIn: 'root'
})
export class TenureInterestsNotificationModalService extends ModalService {
    showModal(props: TenureInterestsNotificationModalProps) {
        this.createModalComponent(TenureInterestsNotificationModalComponent);
        const tenureInterestsNotificationModalComponent = this.modalComponentRef.instance as TenureInterestsNotificationModalComponent;
        tenureInterestsNotificationModalComponent.tenureInterestNotification = props.tenureInterestNotification;
        tenureInterestsNotificationModalComponent.overwritableSubjectVals = props.overwritableSubjectVals;
        console.log('show tenureInterestsNotificationModalComponent');
        this.showModalComponent();
        return tenureInterestsNotificationModalComponent.modalClosed;
    }
}
